import { render } from "./ViewDrawOdds.vue?vue&type=template&id=29dd7fd9&scoped=true"
import script from "./ViewDrawOdds.vue?vue&type=script&lang=js"
export * from "./ViewDrawOdds.vue?vue&type=script&lang=js"

import "./ViewDrawOdds.vue?vue&type=style&index=0&id=29dd7fd9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29dd7fd9"],['__file',"ViewDrawOdds.vue"]])

export default __exports__